/**
 * @generated SignedSource<<f5724cf23d5a5323b342ae15d015179c>>
 * @relayHash e9ba45e99eaeeea80cb3f7137502a898
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0a16379e1d15fa1b22b3dbda6c858b9691d903e5fc059b9b4ae5915847234540

import type { ConcreteRequest } from 'relay-runtime';
export type useContentByLabelDataQuery$variables = {
  cql: string;
  fallbackToBody: boolean;
  first?: number | null;
  includeExcerpt: boolean;
};
export type useContentByLabelDataQuery$data = {
  readonly search: {
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly body: {
          readonly atlas_doc_format?: {
            readonly mediaToken: {
              readonly token: string | null;
            } | null;
          } | null;
        } | null;
        readonly id: string | null;
        readonly labels: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly name: string | null;
          } | null> | null;
        } | null;
        readonly macroExcerpt?: {
          readonly atlasDocFormat: string | null;
        } | null;
        readonly space: {
          readonly id: string | null;
          readonly key: string | null;
          readonly name: string | null;
        } | null;
        readonly subType: string | null;
        readonly type: string | null;
      } | null;
      readonly lastModified: string | null;
      readonly title: string | null;
      readonly url: string | null;
    } | null> | null;
  } | null;
};
export type useContentByLabelDataQuery = {
  response: useContentByLabelDataQuery$data;
  variables: useContentByLabelDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cql"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fallbackToBody"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeExcerpt"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = [
  {
    "alias": "search",
    "args": [
      {
        "kind": "Variable",
        "name": "cql",
        "variableName": "cql"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      }
    ],
    "concreteType": "ConfluenceSearchConnection",
    "kind": "LinkedField",
    "name": "confluence_search",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceSearchResponse",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "kind": "ScalarField",
            "name": "lastModified"
          },
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "name": "type"
              },
              {
                "kind": "ScalarField",
                "name": "subType"
              },
              {
                "condition": "includeExcerpt",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "ConfluenceMacroExcerptBody",
                    "kind": "LinkedField",
                    "name": "macroExcerpt",
                    "plural": false,
                    "selections": [
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "fallbackToBody",
                            "variableName": "fallbackToBody"
                          },
                          {
                            "kind": "Literal",
                            "name": "maxBlocks",
                            "value": 3
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "atlasDocFormat"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "ContentBodyPerRepresentation",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": [
                  {
                    "condition": "includeExcerpt",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "ContentBody",
                        "kind": "LinkedField",
                        "name": "atlas_doc_format",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "EmbeddedMediaToken",
                            "kind": "LinkedField",
                            "name": "mediaToken",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "token"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  (v5/*: any*/)
                ]
              },
              {
                "concreteType": "PaginatedLabelList",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useContentByLabelDataQuery",
    "selections": (v6/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useContentByLabelDataQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "e9ba45e99eaeeea80cb3f7137502a898",
    "id": "0a16379e1d15fa1b22b3dbda6c858b9691d903e5fc059b9b4ae5915847234540",
    "metadata": {},
    "name": "useContentByLabelDataQuery",
    "operationKind": "query",
    "text": "query useContentByLabelDataQuery($cql:String!,$first:Int,$includeExcerpt:Boolean!,$fallbackToBody:Boolean!){search:confluence_search(cql:$cql,first:$first){nodes{title,url,lastModified,content{id,type,subType,macroExcerpt@include(if:$includeExcerpt){atlasDocFormat(fallbackToBody:$fallbackToBody,maxBlocks:3)},body{atlas_doc_format@include(if:$includeExcerpt){mediaToken{token}}},space{id,key,name},labels{nodes{id,name}}}}}}"
  }
};
})();

(node as any).hash = "935c3fd3ae3651ae347360005e14f24e";

export default node;
